import {BaseModel} from "./base.model";
import {Port} from "./port.model";
import {Provider} from "./provider.model";
import {Vehicle} from "./vehicle.model";
import {ShipmentType} from "../interfaces/shipment-type.interface";
import {ShipmentDirection} from "../interfaces/shipment-direction.interface";
import {Deserializable} from "../interfaces/deserializable.interface";
import {TransportServiceCalculation} from "../interfaces/transport-service-calculation.interface";
import {DataEntity} from "./data-entity.model";

export class TransportService extends BaseModel implements Deserializable {
  name: string;
  loadingPort: Port;
  destinationPort: Port;
  provider: Provider;
  vehicle: Vehicle;
  shipmentType: ShipmentType;
  shipmentDirection: ShipmentDirection;
  minHeight: number;
  minWidth: number;
  minLength: number;
  minSize: number;
  maxHeight: number;
  maxWidth: number;
  maxLength: number;
  maxSize: number;
  calculations: TransportServiceCalculation[];
  showTowed: boolean;
  showTracked: boolean;
  showLoading: boolean;
  showDimensionCapture: boolean;
  portAddress: DataEntity;
  active: boolean;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
